"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const commentLikeStore_1 = require("./commentLikeStore");
const ucParamAjaxHelper_1 = require("../lib/ucParamAjaxHelper");
const store_1 = require("../../const/store");
const inject_1 = require("../lib/inject");
const storeEvent_1 = require("../lib/storeEvent");
const inject_2 = require("../lib/inject");
class CommentListV2Store {
    constructor(config) {
        this.currentTab = 'hot';
        this.loadCommentList = async (queryIndex, options) => {
            try {
                const url = `@{apiHost}/v2/api/comment/${this.currentTab === 'hot' ? 'hot' : 'list'}/${this.instance}`;
                const ajax = ucParamAjaxHelper_1.default;
                if (!ajax) {
                    console.error('ucajax not found');
                    throw new Error('ucajax not found');
                }
                const data = await ajax.getJsonWithCommonParams(url, {
                    item_id: this.itemId,
                    query_index: queryIndex,
                });
                if (options && options.noUpdate) {
                    return;
                }
                if (options && options.replace) {
                    this.items = [];
                }
                mobx_1.runInAction(() => {
                    if (data.data) {
                        if (data.data.hotComments) {
                            data.data.hotComments.forEach((item) => {
                                this.items.push(item);
                            });
                        }
                        if (data.data.comments) {
                            data.data.comments.forEach((item) => {
                                this.items.push(item);
                            });
                        }
                        this.page++;
                        this.lastIndex = data.data.lastIndex;
                        this.hasMore = data.data.lastIndex !== -1;
                        this.token = data.data.token;
                        this.likeStore.loadStorageData(this.itemId, this.items, this.instance);
                    }
                });
            }
            catch (ex) {
                // todo
            }
        };
        this.onAddCommentEvent = (newItem) => {
            this.items.unshift(newItem);
        };
        this.total = config.total || 0;
        this.lastIndex = config.lastIndex || -1;
        const items = [].concat(config.hotItems).concat(config.items);
        this.items = items || [];
        this.hasMore = config.lastIndex !== -1;
        this.itemId = config.itemId;
        this.instance = config.instance;
        this.page = 0;
        this.token = config.commentToken;
        if (!inject_2.default.has(store_1.StoreName.CommentLikeStore)) {
            inject_2.default.register(store_1.StoreName.CommentLikeStore, commentLikeStore_1.default, {});
        }
        this.likeStore = inject_1.default.get(store_1.StoreName.CommentLikeStore);
        storeEvent_1.default.addEventHandler('commentInput:add:comment', (event) => {
            this.onAddCommentEvent(event.data.newItem);
        });
        storeEvent_1.default.addEventHandler('commentInput:afterAdd:comment', (event) => {
            this.loadCommentList(0, { noUpdate: true });
        });
        storeEvent_1.default.addEventHandler('commentInput:init:history', (event) => {
            const historyItems = event.data.commentItems;
            historyItems.forEach((item) => {
                const findItem = this.items.find((currItem) => {
                    return currItem.userName === item.userName && currItem.message === item.message;
                });
                if (!findItem) {
                    this.onAddCommentEvent(item);
                }
            });
        });
        this.likeStore.loadStorageData(this.itemId, this.items, this.instance);
        mobx_1.reaction(() => this.total, (total) => {
            storeEvent_1.default.sendEvent('commentInput:total:change', {
                data: { total },
            });
        });
    }
    updateLike(commentItem) {
        this.likeStore.updateLike(commentItem, 'comment', this.token);
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], CommentListV2Store.prototype, "total", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], CommentListV2Store.prototype, "lastIndex", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], CommentListV2Store.prototype, "currentTab", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], CommentListV2Store.prototype, "items", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], CommentListV2Store.prototype, "hasMore", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentListV2Store.prototype, "loadCommentList", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CommentListV2Store.prototype, "updateLike", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentListV2Store.prototype, "onAddCommentEvent", void 0);
exports.default = CommentListV2Store;
//# sourceMappingURL=data:application/json;base64,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